import React, { useEffect, useState } from 'react'
import Layout from '../../Layout/Layout';
import ContactSection1 from './ContactSection1';
import Footer from '../../Layout/Footer';
import BillingDetails from '../BillingDetails/BillingDetails';
import Function_Cart from '../Cart/Function_Cart';
import ContactsAPI from './ContactsAPI';
import ContactAPI1 from './ContactAPI1';
// import FooterCalendar from '../../Layout/FooterCalendar';
import ContactAPI2 from './ContactAPI2';
import FooterNew from '../../Layout/FooterNew';
import SEO from '../../SEO';
import axios from 'axios';
const BASE_URL = "https://ecom.cyberathon.com/index.php/Api"; 
function Contact() {
  const [seoData, setSeoData] = useState({});
  useEffect(() => {
  const fetchSeo = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/get_seo_by_page`, {
        page_name: 'contact'
      });

      if (response.data.status === 'true') {
        const data = response.data.data;
        setSeoData({
          title: data.meta_title,
          description: data.meta_description,
          keywords: data.meta_keywords,
          canonical: data.canonical_url,
        });
      }
    } catch (error) {
      console.error('SEO fetch error:', error);
    }
  };

  fetchSeo();
}, []);
  return (
    <>
    <SEO
  title={seoData.title || "best cupping therapy tools ,authentic cupping supplies | shopeindia"}
  description={seoData.description || "Get in touch with ShopIndia for support, queries, or feedback."}
  keywords={seoData.keywords || "ShopIndia, contact, support, feedback"}
  canonical={seoData.canonical || "https://www.shopindia.com/contact"}
/>
    <Layout/>
    {/* <ContactSection1/>   realone */}
    {/* <ContactsAPI/> */}
    {/* <ContactAPI1/> */}
    <ContactAPI2/>
    {/* <BillingDetails/> */}
    {/* <Function_Cart/> */}
    {/* <Footer/> */}
    {/* <FooterCalendar/> */}
    <FooterNew/>
    </>
  )
}

export default Contact;
